// * @Description: 隐患排查治理
<template>
  <el-card class="h-full">
    <div class="flex flex-col h-full">
      <div class="text-right">
        <el-radio-group v-model="radioValue" size="mini" @input="getKpiList">
          <el-radio-button size="small" :label="0">七天</el-radio-button>
          <el-radio-button size="small" :label="1">1个月</el-radio-button>
          <el-radio-button size="small" :label="2">3个月</el-radio-button>
          <el-radio-button size="small" :label="3">1年</el-radio-button>
        </el-radio-group>
      </div>
      <KpiList :data="list"></KpiList>
      <div class="flex-auto h-0px relative mb-15px  border-inherit border-1 overflow-hidden">
        <div
          class="absolute left-20px top-20px flex justify-between items-center border-color-default pl-20px"
        >
          <p class="border-l-3 border-color-primary pl-10px text-18px">隐患排查完成率趋势</p>
        </div>
        <v-chart
          v-loading="chartLoading"
          :options="lineOption"
          autoresize
          class="w-full h-full overflow-hidden"
        ></v-chart>
      </div>
      <div class="flex-auto h-0px relative  border-inherit border-1 overflow-hidden">
        <div
          class="absolute left-20px top-20px flex justify-between items-center border-color-default pl-20px"
        >
          <p class="border-l-3 border-color-primary pl-10px text-18px">隐患排查次数部门排行</p>
        </div>
        <v-chart
          v-loading="chartLoading"
          :options="barOption"
          autoresize
          class="w-full h-full overflow-hidden"
        ></v-chart>
      </div>
    </div>
  </el-card>
</template>
<script>
import { HiddenDangerStatisticsApi } from '@wiz-api/double-prevention-management'
import KpiList from '../components/KpiList'

const hiddenDangerStatisticsApi = new HiddenDangerStatisticsApi()

export default {
  name: 'troubleshoot-statistics',
  components: {
    KpiList,
  },
  data() {
    return {
      radioValue: 0,
      chartLoading: false,
      list: [
        {
          label: '现场管理类(设备设施类)任务',
          value: 0,
          unit: '',
          color: '#0082ff',
        },
        {
          label: '现场管理类(作业活动)任务',
          value: 0,
          unit: '',
          color: 'red',
        },
        {
          label: '基础管理类任务',
          value: 0,
          unit: '',
          color: 'orange',
        },
        {
          label: '排查任务正常',
          value: 0,
          unit: '',
          color: 'green',
        },
        {
          label: '产生隐患任务',
          value: 0,
          unit: '',
          color: 'green',
        },
      ],
      kpiList: [],
      lineChartLoading: false,
      lineOption: {
        tooltip: {
          show: true,
          trigger: 'axis',
        },
        legend: {
          show: true,
          top: 15,
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            showMaxLabel: true,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
        },
        series: [
          {
            name: '隐患排查完成率',
            // name: '隐患排查完成数',
            data: [],
            type: 'line',
            smooth: true,
          },
        ],
      },
      barOption: {
        tooltip: {
          show: true,
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '排查次数',
            data: [],
            type: 'bar',
            barWidth: 40,
            label: {
              formatter: '',
            },
          },
        ],
      },
    }
  },
  methods: {
    async getKpiList() {
      this.chartLoading = true
      const [
        err,
        res,
      ] = await hiddenDangerStatisticsApi.hiddenDangerInvestigationStatisticalAnalysis({
        timeConditionEnums: this.radioValue,
      })
      if (!err) {
        this.list[0].value = res.taskEquipmentFacilityCount
        this.list[1].value = res.taskJobActivityCount
        this.list[2].value = res.taskBasicManagementCount
        this.list[3].value = res.investigationNormalCount
        this.list[4].value = res.discoverHiddenDangersCount
        if (res.checkCompletionRateTrends) {
          const xData = []
          const yData = []
          const rateList = []
          const option = JSON.parse(JSON.stringify(this.lineOption))
          res.checkCompletionRateTrends.forEach((item) => {
            xData.push(item.timeStr)
            yData.push(item.dailyCompletionCount)
            rateList.push(item.completionRate)
          })
          option.xAxis.data = xData
          // option.series[0].data = yData
          // option.tooltip.formatter = (params) => {
          //   return `${params.name}<br/>${params.marker}${params.seriesName}:${params.value}<br/>${
          //     params.marker
          //   }隐患排查完成率:${rateList[params.dataIndex]}`
          // }
          option.series[0].data = rateList.map((str) => {
            return str.replace('%', '')
          })

          this.lineOption = option
        }
        if (res.checksDepartmentRankingsNumber) {
          const xData = []
          const yData = []
          const option = JSON.parse(JSON.stringify(this.barOption))
          res.checksDepartmentRankingsNumber.forEach((item) => {
            xData.push(item.departmentStr)
            yData.push(item.checksNumber)
          })
          option.xAxis.data = xData
          option.series[0].data = yData
          this.barOption = option
        }
        this.chartLoading = false
      }
    },
  },
  mounted() {
    this.getKpiList()
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
